import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError} from 'rxjs/operators';
import { Article } from '../../models/article';
import { plainToClass } from 'class-transformer';

@Injectable()
export class ArticlesProvider {

  articles: Array<Article> = []
  article: Article

  constructor(private _http: HttpClient,
              private storage: Storage) {
    // need toPromise().then() to force load
  }

  getArticle(slug: String): Observable<any> {
    const observable = new Observable<Article>( observer => {
      this._http.get('/articles/' + slug, {observe: 'response'})
                .pipe(catchError(this.handleError))
                .subscribe(r => {
                  this.article = r.body['data'] as Article
                  observer.next(this.article)
                })
    })
    return observable;
  }



  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened retrieving articles; please try again later.');
  }

}
